import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

const APP_STORE_URL = "https://apps.apple.com/app/smoothspeak/id6739810324";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=ai.smoothspeak.smoothspeak";


export const AppStoreButton = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if the user is on iOS
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);

    // Check if the user is on a mobile device
    const isMobileDevice =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    setIsMobile(isMobileDevice);
  }, []);

  // For mobile devices, show only the relevant store button
  if (isMobile) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 2,
        }}
      >
        {isIOS ? (
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/static/frontend/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
              alt="Download on the App Store"
              style={{ height: "50px" }}
            />
          </a>
        ) : (
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/static/frontend/images/GetItOnGooglePlay_Badge_Web_color_English.png"
              alt="Get it on Google Play"
              style={{ height: "50px" }}
            />
          </a>
        )}
      </Box>
    );
  }

  // For desktop devices, show both buttons side by side
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 2,
        mt: 2,
      }}
    >
      {/* iOS App Store Button */}
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/static/frontend/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
          alt="Download on the App Store"
          style={{ height: "50px" }}
        />
      </a>

      {/* Google Play Store Button */}
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/static/frontend/images/GetItOnGooglePlay_Badge_Web_color_English.png"
          alt="Get it on Google Play"
          style={{ height: "50px" }}
        />
      </a>
    </Box>
  );
};
